<template>
  <div class="card-body">

    <div class="segment">
      <h4 class="text-muted">
        IP's liberados
      </h4>
      <div class="released-ips">
        <span v-if="items.length == 0">Sem dados</span>
        <tr v-for="item in items"
            :key="item.id">
          <td>
            {{item}}
          </td>
        </tr>
      </div>
      <button class="btn btn-primary btn-round"
              @click="refreshReleseadIps()">
        Atualizar Endereços Liberados
      </button>
      <button class="btn btn-primary btn-round"
              @click="cleanReleseadIps()">
        Limpar Endereços Liberados
      </button>

      <!-- <h3 class="server-command"
          v-if="serverCommand && serverCommand != 'NONE'">{{serverCommand}}</h3> -->

    </div>
  </div>

</template>

<script>
    import EventBus from '@packages/event-bus'

    export default {
        components: {
        },

        data() {
            return {
                serverCommand :'',
                serverCommandTimeout : null,
                localId: null,
                items: [],
                headers: [
                    {text: 'IP', value: 'ip'}
                ]
            }
        },

        props: {
            config: {
                type: Object
            }
        },

        methods: {
            register(){
                EventBus.$emit('CREATE_VPN_SUPPORT')
            },
            async load() {
              const res = await this.$api.locals.releasedIps(this.localId)

              this.items = Array.isArray(res) ? res :  [];
            },
            async refreshReleseadIps(){
                let response = await this.$api.locals.refreshReleseadIps(this.localId)
                EventBus.$emit('show-message', {
                    type: 'SUCCESS',
                    message: response.message,
                    timeout: 3000,
                })
            },
            async cleanReleseadIps(){
                let response = await this.$api.locals.cleanReleseadIps(this.localId)
                EventBus.$emit('show-message', {
                    type: 'SUCCESS',
                    message: response.message,
                    timeout: 3000,
                })
            },
            // async loadServerCommand(){
            //     let response = await this.$api.devices.command(this.deviceId)
            //     this.serverCommand = response
            //     window.clearTimeout(this.serverCommandTimeout)
            //     this.serverCommandTimeout = setTimeout(() => {
            //         this.loadServerCommand()
            //     }, 10000);
            // },
            loadReleseadIpsHandler(local) {
              this.serverCommand = '';
              this.localId = local.id
              this.items = []
              this.load()
              // this.loadServerCommand()
            }

        },
        mounted() {
            EventBus.$on('LOAD_RELESEAD_IPS', this.loadReleseadIpsHandler)
        },
        beforeDestroy() {
            EventBus.$off('LOAD_RELESEAD_IPS', this.loadReleseadIpsHandler)
        },
        destroy(){
            window.clearTimeout(this.serverCommandTimeout)
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.released-ips {
  margin-bottom: 10px;
}

.card-body {
  padding: 0px 50px 10px;

  .segment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .wifeed-active {
    margin-top: 10px;
  }

  .box .box-wrapper {
    border-radius: 30px !important;
  }

  .buttons {
    width: 340px;
    border: none !important;
  }

  .v-btn-toggle {
    box-shadow: unset;
  }
  button {
    margin: 3px;
  }

  td {
    border-bottom: solid;
    border-width: 1px;
    border-color: #d2d2d2;
    padding: 6px;
    width: 370px;
  }

  .server-command {
    margin-top: 10px;
  }
}
</style>
